var map = {
	"./env.doorauth.json": "./src/config/spec/env.doorauth.json",
	"./env.dtlab.json": "./src/config/spec/env.dtlab.json",
	"./env.passit.json": "./src/config/spec/env.passit.json",
	"./env.pwan.json": "./src/config/spec/env.pwan.json"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/config/spec sync recursive ^\\.\\/env\\..*\\.json$";